import AllBrandsPage from '../../features/allBrands/pages/AllBrandsPage'
import BrandDetailsPage from '../../features/brandDetails/pages/BrandDetailsPage'
import { BrandDetailsProvider } from '../../features/brandDetails/context/BrandDetailsContext'
import SettingsPage from '../../features/settings/pages/SettingsPage'
import AssistantPage from '../../features/chat/pages/AssistantPage'
import { PERMISSIONS } from '../roleAccess/config/roleConfig'
import {
  ROUTE_ASSISTANT,
  ROUTE_BRANDS,
  ROUTE_BRAND_DETAILS,
  ROUTE_SETTINGS,
} from './routes'

export const appRoutes = [
  {
    path: ROUTE_ASSISTANT,
    element: <AssistantPage />,
    protected: true,
  },
  {
    path: ROUTE_BRANDS,
    element: <AllBrandsPage />,
    protected: true,
  },
  {
    path: ROUTE_BRAND_DETAILS,
    element: (
      <BrandDetailsProvider>
        <BrandDetailsPage />
      </BrandDetailsProvider>
    ),
    protected: true,
  },
  {
    path: ROUTE_SETTINGS,
    element: <SettingsPage />,
    permission: PERMISSIONS.MANAGE_SETTINGS,
    protected: true,
  },
]
